(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["s2g-404"]) return;
  try {
    
/* Bestsellers rail controls, ported from the mockup's [data-rail] block.
   Scrolls by exactly one card (card width + the 8px gap) and keeps the
   "01 / 04" counter and the disabled states in sync with scrollLeft. */
(function () {
  function init(sec) {
    var rail = sec.querySelector('.cards');
    var ctl = sec.querySelector('.ctl');
    if (!rail || !ctl) return;
    var tiles = Array.prototype.slice.call(rail.children);
    if (!tiles.length) return;
    var cnt = ctl.querySelector('.cnt');
    var pv = ctl.querySelector('.prev');
    var nx = ctl.querySelector('.next');
    function pad(n) { return ('0' + n).slice(-2); }
    function step() { return tiles[0].getBoundingClientRect().width + 8; }
    function upd() {
      var k = Math.round(rail.scrollLeft / step());
      if (cnt) cnt.textContent = pad(Math.min(k, tiles.length - 1) + 1) + ' / ' + pad(tiles.length);
      if (pv) pv.disabled = rail.scrollLeft < 4;
      if (nx) nx.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    }
    if (pv) pv.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (nx) nx.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.s2g-404[data-rail]'), init);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s2g-cart"]) return;
  try {
    

/* Cart behaviour. Every change goes through Shopify's /cart/change.js or
   /cart/add.js and then reloads, so the cart the customer sees is always the
   cart Shopify holds -- no optimistic UI that can drift from the real total. */
(function () {
  /* There are THREE .s2g-cart roots on the page (head, columns, empty state),
     so querySelector('.s2g-cart') returns the head and nothing inside it is
     found. Scope to the columns block, which holds the items, the suggestions
     and the side column; fall back to the document. */
  var root = document.querySelector('.s2g-cart.cart-cols') || document;
  if (!document.querySelector('.s2g-cart')) return;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }
  function reload() { window.location.reload(); }

  /* Shipping protection. The drawer section owns the toggle (both switches act on
     the same cart, so one owner means they cannot disagree). This local copy runs
     only if the drawer is not on the page. Intent is read from the CART, never
     from aria-checked, because this code writes aria-checked itself. */
  function paintProtectionLocal(on) {
    document.querySelectorAll('[data-protection]').forEach(function (el) {
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }
  var protBusyLocal = false;
  function protToggleLocal(vid) {
    if (protBusyLocal) return;
    protBusyLocal = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var line = (c.items || []).filter(function (i) { return i.variant_id === vid; })[0];
        paintProtectionLocal(!line);
        return line
          ? post('/cart/change.js', { id: line.key, quantity: 0 }).then(function () { return false; })
          : post('/cart/add.js', { items: [{ id: vid, quantity: 1 }] }).then(function () { return true; });
      })
      .then(function (nowOn) { protBusyLocal = false; paintProtectionLocal(nowOn); protSync(nowOn); })
      .catch(function () { protBusyLocal = false; reload(); });
  }

  /* Called by the drawer after it changes the cart: repaint this section's money
     and ladder from a fresh server render. `known` is the state just written, so
     the switch is NOT taken from markup that was rendered before the change. */
  window.s2gSyncProtection = function (known) { protSync(known); };
  function protSync(known) {
    var wrap = root.closest ? root.closest('[id^="shopify-section-"]') : null;
    var sid = wrap ? wrap.id.replace(/^shopify-section-/, '') : '';
    if (!sid) { return; }
    fetch(window.location.pathname + '?sections=' + encodeURIComponent(sid), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var html = j && j[sid];
        if (!html) { return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        [['[data-subtotal]'], ['[data-checkout-btn]']].forEach(function (pair) {
          var fresh = doc.querySelector(pair[0]);
          if (!fresh) return;
          document.querySelectorAll(pair[0]).forEach(function (el) { el.textContent = fresh.textContent; });
        });
        var freshLad = doc.querySelector('.lad');
        var lad = root.querySelector('.lad');
        if (freshLad && lad) { lad.setAttribute('data-goods', freshLad.getAttribute('data-goods') || '0'); paintLadder(); }
        if (typeof known === 'boolean') { paintProtectionLocal(known); }
      }).catch(function () {});
  }

  /* quantity steppers and Remove */
  document.addEventListener('click', function (e) {
    /* 2026-09-28: on the phone /cart page the drawer opens over this section, and a
       tap on the DRAWER's + bubbled here too: one tap sent change.js qty 2 (drawer)
       and qty 1 (this section), so the quantity often stayed put. The drawer owns
       its own steppers, remove and switch; this section handles only its own markup. */
    if (e.target.closest('.drawer, [data-drawer]')) { return; }
    var step = e.target.closest('[data-step]');
    if (step) {
      var row = step.closest('.citem');
      var qv = row && row.querySelector('.qv');
      var now = qv ? parseInt(qv.textContent, 10) || 0 : 0;
      var next = now + parseInt(step.getAttribute('data-step'), 10);
      if (next < 0) next = 0;
      post('/cart/change.js', { id: step.getAttribute('data-key'), quantity: next }).then(reload);
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) {
      post('/cart/change.js', { id: rm.getAttribute('data-remove'), quantity: 0 }).then(reload);
      return;
    }
    /* shipping protection. 2026-09-21 Ales: "in the cart the shipping protection is not
       working, nothing happens". The old path was post().then(reload): when the request
       failed (or a third-party fetch wrapper broke the JSON body) the page either reloaded
       unchanged or did nothing, with no message. Now, like the drawer (note 12): the switch
       flips at once, the page reloads on any successful response, and on failure the switch
       flips back and the line under the title shows Shopify's reason (or t_prot_err). */
    var tg = e.target.closest('[data-protection]');
    if (tg) {
      /* 2026-09-24, Ales: the switch "jumps back to activated". Root cause, from
         a log of every /cart request: the OFF change.js returned 200 and removed
         the line, then an add.js fired straight after and put it back. The re-add
         came from the handler deriving intent from aria-checked, which this code
         had itself just rewritten during a re-render, so it read its own output
         instead of the customer's intent.

         Intent now comes from the live cart, never from the DOM. The drawer owns
         the toggle because both switches share one cart; this section just calls
         it, so the two can never disagree. */
      /* Both sections listen on document, so a click on the DRAWER's switch
         bubbles here too. Measured: one tap fired an add AND a change, which
         cancelled out and left protection unchanged. The drawer owns its own
         switch; this section only handles the one in its own markup. */
      if (tg.closest('.drawer, [data-drawer]')) { return; }
      var pv = parseInt(tg.getAttribute('data-protection'), 10);
      if (typeof window.s2gToggleProtection === 'function') { window.s2gToggleProtection(pv); }
      else { protToggleLocal(pv); }
      return;
    }
    /* routine suggestion ticks */
    var qs = e.target.closest('.rcard .qs');
    if (qs) {
      var pressed = qs.getAttribute('aria-pressed') === 'true';
      qs.setAttribute('aria-pressed', pressed ? 'false' : 'true');
      /* 2026-09-24, Ales: "when i click on add the swoosh disapers ... it should
         only have empty box to click". It used to toggle the `tick` CLASS off
         here, but every rule that draws this control is on `.qs.tick` (the 44px
         box, the border, the background), so deselecting removed the button's
         whole appearance instead of emptying it. aria-pressed alone already
         drives the two states: pressed = indigo box with the check, not pressed
         = bordered empty box. So the class must stay put. */
      paintUpsell();
      return;
    }
    /* add every ticked suggestion */
    var all = e.target.closest('[data-addall]');
    if (all) {
      var items = [];
      root.querySelectorAll('.rcard').forEach(function (c) {
        var b = c.querySelector('.qs');
        if (b && b.getAttribute('aria-pressed') === 'true') {
          items.push({ id: parseInt(c.getAttribute('data-variant'), 10), quantity: 1 });
        }
      });
      if (items.length) post('/cart/add.js', { items: items }).then(reload);
    }
  });

  /* the upsell line under the suggestions */
  function paintUpsell() {
    var cards = Array.prototype.slice.call(root.querySelectorAll('.rcard'));
    var on = cards.filter(function (c) {
      var b = c.querySelector('.qs');
      return b && b.getAttribute('aria-pressed') === 'true';
    });
    var sum = on.reduce(function (t, c) { return t + (parseInt(c.getAttribute('data-price'), 10) || 0); }, 0);
    var l = root.querySelector('[data-l]'), s = root.querySelector('[data-sum]');
    var btn = root.querySelector('[data-addall]');
    if (l) l.textContent = on.length + ' ' + (l.getAttribute('data-word') || '');
    if (s) s.textContent = (s.getAttribute('data-word') || '') + ' €' + sum;
    if (btn) btn.disabled = on.length === 0;
  }

  /* the rewards ladder */
  function paintLadder() {
    var lad = root.querySelector('.lad');
    if (!lad) return;
    var cents = parseInt(lad.getAttribute('data-goods'), 10) || 0;
    var eur = cents / 100;
    var tiers = [95, 100, 200];
    lad.querySelectorAll('[data-tier]').forEach(function (t) {
      t.classList.toggle('hit', eur >= parseInt(t.getAttribute('data-tier'), 10));
    });
    var bar = lad.querySelector('[data-ladder-bar]');
    if (bar) bar.style.width = Math.max(0, Math.min(100, (eur / 200) * 100)) + '%';
  }

  paintUpsell();
  paintLadder();

  /* 2026-09-24, Ales: he found a cart holding ONLY shipping protection. Proof
     from his own /cart.js: item_count 1, total_price 590, the single line being
     variant 56756476346754. Reproduced here: turn protection on, then remove the
     product, and the protection line survives on its own. The page then renders
     the EMPTY state while the cart still carries EUR 5,90, so a customer could
     check out paying to insure nothing.

     Protection is an add-on to real goods, so it cannot outlive them. If no real
     product is left, drop it. Shopify is the source of truth here: this reads
     /cart.js rather than trusting anything rendered, and only touches the cart
     when the line is genuinely orphaned. */
  (function dropOrphanProtection() {
    /* The id is written literally: this block is not processed by Liquid, so an
       interpolated value would ship as raw text. It matches prot_variant above. */
    var PROT = 56756476346754;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.items || !c.items.length) return;
        var prot = null, goods = 0;
        c.items.forEach(function (i) {
          if (i.variant_id === PROT) { prot = i; } else { goods += i.quantity; }
        });
        if (!prot || goods > 0) return;
        return post('/cart/change.js', { id: prot.key, quantity: 0 })
          .then(function () { location.reload(); });
      })
      .catch(function () { /* leave the cart untouched if anything fails */ });
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s2g-collection"]) return;
  try {
    
/* Concern chips and sort, ported from the mockup. Filtering is client-side on
   the already-rendered grid, exactly as the mockup does it: no page reload, and
   the count updates with the filter. */
(function () {
  var grid = document.getElementById('s2g-grid');
  if (!grid) return;
  var wraps = Array.prototype.slice.call(grid.children);
  /* on a concern page the chips are links, not buttons - nothing to wire */
  var chips = Array.prototype.slice.call(document.querySelectorAll('.s2g-coll button.chip'));
  var sel = document.getElementById('s2g-sortsel');
  var count = document.getElementById('s2g-count');
  var concern = 'all';

  function visible(w) {
    if (concern === 'all') return true;
    return (' ' + (w.getAttribute('data-concern') || '') + ' ').indexOf(' ' + concern + ' ') !== -1;
  }
  function apply() {
    var n = 0;
    wraps.forEach(function (w) {
      var on = visible(w);
      w.hidden = !on;
      if (on) n++;
    });
    if (count) count.textContent = n + ' ' + (count.dataset.word || '');
  }
  function sort(mode) {
    var arr = wraps.slice();
    if (mode === 'price-asc') arr.sort(function (a, b) { return (+a.dataset.price) - (+b.dataset.price); });
    else if (mode === 'price-desc') arr.sort(function (a, b) { return (+b.dataset.price) - (+a.dataset.price); });
    else if (mode === 'az') arr.sort(function (a, b) { return (a.dataset.name || '').localeCompare(b.dataset.name || ''); });
    arr.forEach(function (w) { grid.appendChild(w); });
  }
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      chips.forEach(function (x) { x.classList.toggle('on', x === c); });
      concern = c.getAttribute('data-filter-concern') || 'all';
      apply();
    });
  });
  if (sel) sel.addEventListener('change', function () { sort(sel.value); });
  apply();
})();

/* Back-in-stock modal. 2026-09-24, Ales asked for the product page's notify form
   to pop up over the grid instead of navigating away, so that after sending the
   request the customer "can continue where he was in the first place".

   One dialog serves every card: the clicked button supplies the variant id and
   the product name. The request is the SAME Klaviyo client back-in-stock call the
   product page makes, so there is a single integration to maintain. On close the
   page is untouched, so scroll position, chips and filters all survive. */
(function () {
  var dlg = document.querySelector('[data-bisd]');
  if (!dlg) return;
  var box = dlg.querySelector('.bisd-box'),
      form = dlg.querySelector('.bisd-form'),
      body = dlg.querySelector('[data-bisd-body]'),
      email = dlg.querySelector('input[type="email"]'),
      go = dlg.querySelector('.bisd-go'),
      news = dlg.querySelector('input[name="news"]'),
      msg = dlg.querySelector('.bisd-msg'),
      row = dlg.querySelector('.bisd-row'),
      lab = dlg.querySelector('.bisd-l'),
      opt = dlg.querySelector('.bisd-opt'),
      con = dlg.querySelector('.bisd-c');
  var tmpl = body.textContent, variant = null, opener = null, lockedAt = 0;
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function say(t, ok) { msg.textContent = t; msg.hidden = false; msg.classList.toggle('ok', !!ok); }
  function reset() {
    msg.hidden = true; msg.classList.remove('ok');
    row.hidden = false; lab.hidden = false; opt.hidden = false; con.hidden = false;
    go.disabled = false; email.value = ''; if (news) news.checked = false;
  }
  function open(btn) {
    opener = btn;
    variant = btn.getAttribute('data-variant');
    var name = btn.getAttribute('data-name') || '';
    body.textContent = tmpl.replace('{name}', name);
    reset();
    dlg.hidden = false;
    /* Remember where the customer was. Do NOT pin the body with position:fixed:
       this dialog is a child of <body>, so that takes the dialog off screen too.
       overflow:hidden on the root is enough to stop the page behind scrolling,
       and the offset is restored explicitly on close. */
    lockedAt = window.scrollY;
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { email.focus({ preventScroll: true }); }, rm ? 0 : 60);
  }
  function close() {
    dlg.hidden = true;
    document.documentElement.style.overflow = '';
    window.scrollTo(0, lockedAt);
    /* hand focus back to the card the customer came from, so they are exactly
       where they were, including for keyboard and screen-reader users */
    if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
    opener = null;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bisd-open]');
    if (btn) { e.preventDefault(); open(btn); return; }
    if (e.target.closest('[data-bisd-close]')) { close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !dlg.hidden) close();
    if (e.key === 'Tab' && !dlg.hidden) {
      /* keep focus inside the dialog while it is open */
      var f = box.querySelectorAll('button,[href],input,select,textarea');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var v = (email.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { say(box.dataset.bad); email.focus(); return; }
    go.disabled = true; msg.hidden = true;
    function post(url, payload) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2025-04-15' },
                          body: JSON.stringify(payload) });
    }
    var bis = { data: { type: 'back-in-stock-subscription', attributes: {
      profile: { data: { type: 'profile', attributes: { email: v } } }, channels: ['EMAIL'] },
      relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } } } } };
    post('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + box.dataset.company, bis)
      .then(function (r) {
        if (!r.ok) throw new Error('bis ' + r.status);
        if (news && news.checked && box.dataset.list) {
          var sub = { data: { type: 'subscription', attributes: {
            profile: { data: { type: 'profile', attributes: { email: v } } } },
            relationships: { list: { data: { type: 'list', id: box.dataset.list } } } } };
          return post('https://a.klaviyo.com/client/subscriptions/?company_id=' + box.dataset.company, sub).catch(function () {});
        }
      })
      .then(function () {
        /* the ask is done: hide the inputs and leave only the confirmation, so
           the customer can close and carry on without wondering if it worked */
        row.hidden = true; lab.hidden = true; opt.hidden = true; con.hidden = true;
        say(box.dataset.ok, true);
      })
      .catch(function () { go.disabled = false; say(box.dataset.err); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s2g-drawer"]) return;
  try {
    
/* Drawer behaviour. Opening and closing is driven by the theme's own bag
   button; every cart change goes through Shopify's /cart endpoints and then
   reloads, so the drawer always shows the cart Shopify actually holds. */
(function () {
  var drawer = document.querySelector('[data-drawer]');
  if (!drawer) return;
  var backdrop = document.querySelector('[data-drawer-backdrop]');

  function open() {
    drawer.classList.add('open');
    if (backdrop) backdrop.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('open');
    if (backdrop) backdrop.classList.remove('open');
    document.documentElement.style.overflow = '';
    if (cartPageOnPhone) leaveCartPage();
  }
  /* 2026-09-21 Ales: on the phone the cart is the drawer, never the /cart page. The free-gift
     app's "Go To Cart" button (and any other link) still navigates to /cart, and that click is
     also the moment the app adds the chosen reward, so it is not blocked. Instead, when /cart
     loads on a phone the drawer opens over it at once, and closing the drawer returns to the
     page the customer came from (the locale's home when there is none). Desktop keeps the page. */
  var cartPageOnPhone = /\/cart\/?$/.test(location.pathname) && window.matchMedia('(max-width:767px)').matches;
  function leaveCartPage() {
    var ref = document.referrer;
    var root = location.pathname.replace(/cart\/?$/, '') || '/';
    var back = ref && ref.indexOf(location.origin) === 0 && !/\/cart\/?(\?|#|$)/.test(ref) ? ref : root;
    window.location.href = back;
  }
  window.s2gOpenDrawer = open;
  window.s2gCloseDrawer = close;

  /* 2026-09-15, Ales: "do the cart drawer as the mockup". Nothing opened THIS drawer after
     an add: the theme's ProductForm posts /cart/add.js and the Section Store app's own
     drawer took over (its "intercept add to cart" / "intercept cart links" settings, to be
     switched off in that app). So: hook the same fetch, re-render this section through the
     Section Rendering API (rows, ladder, totals = the cart Shopify holds), rebind, open. */
  var wrap = drawer.closest('.shopify-section');
  var sectionId = wrap ? wrap.id.replace(/^shopify-section-/, '') : '';
  /* apply one rendered copy of this section (from ?sections= or from the add response) */
  function apply(html) {
    if (!html) return false;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-drawer]');
    if (!fresh) return false;
    var oldRow = drawer.querySelector('.uprow'), railX = oldRow ? oldRow.scrollLeft : 0;
    drawer.innerHTML = fresh.innerHTML;
    drawer.setAttribute('data-count', fresh.getAttribute('data-count') || '0');
    var newRow = drawer.querySelector('.uprow');
    if (newRow && railX) newRow.scrollLeft = railX;  /* note 8: the rail stays where the customer left it */
    bindRail(); paintLadder(); paintBadge();
    return true;
  }
  function refresh() {
    if (!sectionId) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { apply(j && j[sectionId]); })
      .catch(function () {});
  }
  window.s2gRefreshDrawer = refresh;

  /* shipping protection: desired state + a single worker (see the click handler) */
  /* Shipping protection, single source of truth = the CART.
     protBusy serialises clicks so two taps cannot race; the pending wish is kept
     so the LAST tap still wins. Nothing here reads aria-checked to decide what to
     do, because this code writes aria-checked itself. */
  var protBusy = false, protPending = null;
  function paintProtection(on) {
    document.querySelectorAll('[data-protection]').forEach(function (el) {
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }
  window.s2gPaintProtection = paintProtection;
  window.s2gToggleProtection = function (vid) { protToggle(vid); };

  function protToggle(vid) {
    if (protBusy) { protPending = vid; return; }
    protBusy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var line = (c.items || []).filter(function (i) { return i.variant_id === vid; })[0];
        var on = !!line;
        paintProtection(!on);                     /* optimistic, so the tap feels instant */
        return on
          ? post('/cart/change.js', { id: line.key, quantity: 0 }).then(function () { return false; })
          : post('/cart/add.js', { items: [{ id: vid, quantity: 1 }] }).then(function () { return true; });
      })
      .then(function (nowOn) {
        protBusy = false;
        paintProtection(nowOn);
        return refresh().then(function () {
          paintProtection(nowOn);                 /* refresh() redraws the switch from
                                                     markup rendered BEFORE the change */
          if (typeof window.s2gSyncProtection === 'function') { window.s2gSyncProtection(nowOn); }
        });
      })
      .then(function () {
        if (protPending !== null) { var v = protPending; protPending = null; protToggle(v); }
      })
      .catch(function () {
        protBusy = false;
        /* fall back to whatever the cart really says */
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { paintProtection((c.items || []).some(function (i) { return i.variant_id === vid; })); })
          .catch(function () {});
      });
  }
  /* 2026-09-15 Ales note 11: the free-gift app (docapp) reloads the page after it adds a reward, because
     it finds no cart drawer it can refresh in place - and the reload closes this drawer. Its script honours
     these two theme-side hooks: no reloads outside /cart, and a callback to refresh the drawer instead. */
  window.freeGiftCartUpsellProAppDisableRefreshExceptOnCart = true;
  if (typeof window.do_cart_refresh !== 'function') {
    window.do_cart_refresh = function () { refresh().then(function () { if (!drawer.classList.contains('open')) open(); }); };
  }
  /* 2026-09-15 Ales note 4: the card's quick-add button showed no sign that anything happened.
     The tick (.checki) and the .bagb.added styling were already built and simply never switched on.
     The button belongs to the host theme's ProductForm, which posts /cart/add.js itself - so we do
     NOT post again (that would add the product twice); we remember which button was pressed and
     flip it when that request succeeds. Capture phase, because the form submits on the same click. */
  var lastBag = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.bagb') : null;
    lastBag = b || null;
  }, true);

  /* 2026-09-29 Ales: "can it add immediately, without the turning circle?" Shopify has to accept
     the add (0.5s wifi, 1-3s mobile), so the bag opens AT ONCE with the product as a placeholder
     row, and the real render (from the add response) replaces it. If Shopify refuses, the row says
     so and the real bag is shown; if no add request leaves at all, the real bag returns after 3s.
     Product facts come from data-opt-* on the PDP sticky bar. Product pages only. */
  var optT = null, optSent = false;
  var OPT = {
    hr: ['Dodaje se\u2026', 'Nije dodano. Poku\u0161ajte ponovno.'],
    de: ['Wird hinzugef\u00fcgt\u2026', 'Nicht hinzugef\u00fcgt. Bitte erneut versuchen.'],
    sl: ['Dodajanje\u2026', 'Ni dodano. Poskusite znova.'],
    en: ['Adding\u2026', 'Could not add. Please try again.']
  }[(document.documentElement.lang || 'en').slice(0, 2).toLowerCase()] || ['Adding\u2026', 'Could not add. Please try again.'];
  function esc(t) { var e = document.createElement('span'); e.textContent = t || ''; return e.innerHTML; }
  function optShow() {
    var src = document.querySelector('.s2g-satc[data-opt-name]');
    if (!src) return false;
    var row = document.createElement('div');
    row.className = 'li s2g-opt';
    row.setAttribute('aria-live', 'polite');
    row.innerHTML = '<span class="im">' + (src.getAttribute('data-opt-img') ? '<img src="' + esc(src.getAttribute('data-opt-img')) + '" alt="">' : '') + '</span>' +
      '<div class="li-mid"><div class="li-top"><div style="min-width:0"><h3>' + esc(src.getAttribute('data-opt-name')) + '</h3></div>' +
      '<div class="li-price">' + esc(src.getAttribute('data-opt-price')) + '</div></div>' +
      '<p class="s2g-opt-msg">' + OPT[0] + '</p></div><i class="s2g-opt-bar" aria-hidden="true"></i>';
    var items = drawer.querySelector('.items');
    if (!items) {
      items = document.createElement('div'); items.className = 'items';
      var empty = drawer.querySelector('.bagh'); if (empty) empty.style.display = 'none';
      var head = drawer.querySelector('.dhead'); if (head && head.nextSibling) drawer.insertBefore(items, head.nextSibling); else drawer.appendChild(items);
    }
    items.insertBefore(row, items.firstChild);
    drawer.scrollTop = 0;
    open();
    return true;
  }
  function optDone() { clearTimeout(optT); optT = null; optSent = false; }
  function optFail() {
    clearTimeout(optT); optT = null; optSent = false;
    var row = drawer.querySelector('.s2g-opt');
    if (row) { row.classList.add('err'); var m = row.querySelector('.s2g-opt-msg'); if (m) m.textContent = OPT[1]; }
    setTimeout(refresh, 2500);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.s2g-pdp .s2g-atc, .s2g-satc .s2g-atc') : null;
    if (!b || b.type !== 'submit' || b.disabled || b.closest('.s2g-bis-form')) return;
    if (drawer.querySelector('.s2g-opt')) return;       /* one placeholder at a time */
    optSent = false;
    if (!optShow()) return;
    /* the add must leave within 3s; otherwise (validation stopped it, a script error) show the real bag */
    optT = setTimeout(function () { if (!optSent) refresh(); }, 3000);
  });

  if (!document.documentElement.dataset.s2gDrawerHook) {
    document.documentElement.dataset.s2gDrawerHook = '1';
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      /* 2026-09-29 one round trip: ask Shopify to render this drawer in the add response itself
         (Section Rendering on /cart/add), instead of a second ?sections= request afterwards.
         Only for FormData / JSON bodies; anything else goes out untouched. */
      if (isAdd && sectionId && init && init.body) {
        try {
          if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
            var have = init.body.get('sections');
            init.body.set('sections', have ? have + ',' + sectionId : sectionId);
            if (!init.body.get('sections_url')) init.body.set('sections_url', window.location.pathname);
          } else if (typeof init.body === 'string' && init.body.charAt(0) === '{') {
            var jb = JSON.parse(init.body);
            jb.sections = jb.sections ? [].concat(jb.sections, sectionId) : sectionId;
            if (!jb.sections_url) jb.sections_url = window.location.pathname;
            init.body = JSON.stringify(jb);
          }
        } catch (err) { /* leave the request exactly as the theme built it */ }
      }
      if (isAdd) optSent = true;
      var p = origFetch.call(this, input, init);
      if (isAdd) {
        var btn = lastBag;
        lastBag = null;
        p.then(function (res) {
          if (!res || !res.ok) { optFail(); return; }
          if (btn) { btn.classList.add('added'); btn.setAttribute('aria-pressed', 'true'); }
          res.clone().json().then(function (j) {
            var html = j && j.sections && j.sections[sectionId];
            if (apply(html)) { open(); optDone(); } else { refresh().then(function () { open(); optDone(); }); }
          }).catch(function () { refresh().then(function () { open(); optDone(); }); });
        }).catch(function () { optFail(); });
      }
      return p;
    };
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-drawer-backdrop]')) {
      close();
      return;
    }
  });
  /* the bag icon / cart links: CAPTURE phase, so this runs before the Section Store app's own
     cart-link interceptor (it stops the event and opened its drawer; hidden on this theme
     since 2026-09-15, the click then did nothing at all). Ours opens and swallows the click. */
  document.addEventListener('click', function (e) {
    var bag = e.target.closest('.cart-drawer-button, [data-cart-drawer-open], a[href$="/cart"]');
    if (bag && !e.target.closest('[data-drawer]')) {
      e.preventDefault();
      e.stopPropagation();
      refresh().then(open);
    }
  }, true);
  /* 2026-09-21 Ales: in the free-gift app's "Choose your free reward" popup, tapping "Add To Cart"
     under a reward only greys that button and the popup stays put; the customer expects it to move
     on like the popup's own "Go To Cart" does. The app's "action when the selection is complete"
     setting is empty on this store, so the theme does it: after the app has handled the tap, if no
     reward button is left to choose, press the popup's "Go To Cart" for the customer (that click is
     where the app adds the rewards; on a phone it lands in this drawer). If another reward group is
     still open, scroll the popup to it instead. */
  document.addEventListener('click', function (e) {
    var pick = e.target.closest('.docapp-overlay-container .docapp-add-to-cart');
    if (!pick) return;
    setTimeout(function () {
      var modal = document.querySelector('.docapp-overlay-container');
      if (!modal) return;
      var left = modal.querySelector('.docapp-add-to-cart:not([disabled])');
      if (left) {
        var group = left.closest('.docapp-gift-choices') || left;
        group.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var go = modal.querySelector('.docapp-gift-choice-modal-cart-button');
      if (go) go.click();
    }, 150);
  }, true);   /* capture: the popup's content stops clicks from bubbling out */

  /* 2026-09-29 Ales: the free-gift picker (Dr Free Gift, .docapp-*) is English in every language.
     The app holds ONE wording per label, so the theme translates its fixed phrases into the page
     language when the picker is drawn. Exact-match only: product names and prices are untouched,
     and English pages are left alone. Runs on each redraw (the app re-renders the popup). */
  (function () {
    var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var T = {
      hr: { 'Choose your free reward! 🎁': 'Odaberite svoj besplatni poklon! 🎁',
            'You can choose any reward.': 'Možete odabrati bilo koji poklon.',
            'FREE': 'BESPLATNO', 'Add to cart': 'Dodajte u košaricu', 'No, thanks!': 'Ne, hvala!',
            'Continue Shopping': 'Nastavite kupnju', 'Go to cart': 'Idite u košaricu' },
      de: { 'Choose your free reward! 🎁': 'Wählen Sie Ihr Gratis-Geschenk! 🎁',
            'You can choose any reward.': 'Sie können ein beliebiges Geschenk wählen.',
            'FREE': 'GRATIS', 'Add to cart': 'In den Warenkorb', 'No, thanks!': 'Nein, danke!',
            'Continue Shopping': 'Weiter einkaufen', 'Go to cart': 'Zum Warenkorb' },
      sl: { 'Choose your free reward! 🎁': 'Izberite svoje brezplačno darilo! 🎁',
            'You can choose any reward.': 'Izberete lahko katero koli darilo.',
            'FREE': 'BREZPLAČNO', 'Add to cart': 'Dodajte v košarico', 'No, thanks!': 'Ne, hvala!',
            'Continue Shopping': 'Nadaljujte nakup', 'Go to cart': 'Pojdite v košarico' }
    }[lang];
    if (!T) return;
    var SEL = '.docapp-gift-choice-modal-title, .docapp-gift-choice-modal-sub-title, ' +
              '.docapp-gift-choice-modal-gift-price, .docapp-add-to-cart, ' +
              '.docapp-gift-choice-modal-decline-button, .docapp-gift-choice-modal-done-button, ' +
              '.docapp-gift-choice-modal-cart-button';
    function tr(root) {
      root.querySelectorAll(SEL).forEach(function (el) {
        var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
        while ((n = w.nextNode())) {
          var k = n.nodeValue.trim();
          if (T[k] && n.nodeValue.trim() !== T[k]) n.nodeValue = n.nodeValue.replace(k, T[k]);
        }
      });
    }
    var busy = false;
    new MutationObserver(function () {
      if (busy) return;
      var m = document.querySelector('.docapp-overlay-container');
      if (!m) return;
      busy = true; tr(m); busy = false;
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  })();

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* 2026-09-24: this used to resolve on ANY response, so a 4xx/5xx from Shopify
     looked like success. Measured on a phone: an OFF for shipping protection
     failed, the worker treated it as done, and the line stayed in the cart
     through a reload. A non-ok response must reject. */
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body), credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) { return r.text().then(function (t) { throw t; }, function () { throw ''; }); }
      return r.json().catch(function () { return null; });
    });
  }
  /* 2026-09-15 Ales note 7: +/- and remove closed the whole drawer (page reload). Now the
     section re-renders in place and the header badge follows. */
  function paintBadge() {
    var n = parseInt(drawer.getAttribute('data-count'), 10) || 0;
    document.querySelectorAll('[data-cart-drawer-open], .cart-drawer-button').forEach(function (a) {
      var b = a.querySelector('.bagn');
      if (n > 0) { if (!b) { b = document.createElement('span'); b.className = 'bagn'; a.appendChild(b); } b.textContent = n; }
      else if (b) b.remove();
    });
  }

  drawer.addEventListener('click', function (e) {
    var step = e.target.closest('[data-step]');
    if (step) {
      var row = step.closest('.li');
      var qv = row && row.querySelector('.qv');
      var next = (qv ? parseInt(qv.textContent, 10) || 0 : 0) + parseInt(step.getAttribute('data-step'), 10);
      if (next < 0) next = 0;
      post('/cart/change.js', { id: step.getAttribute('data-key'), quantity: next }).then(refresh);
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) { post('/cart/change.js', { id: rm.getAttribute('data-remove'), quantity: 0 }).then(refresh); return; }

    var tg = e.target.closest('[data-protection]');
    if (tg) {
      /* 2026-09-24, Ales: "it start as deactivated but once i activate it and try
         to deactivate it jumps back to activated".

         Root cause, found by logging every /cart request: the OFF change.js
         returned 200 and removed the line, and an add.js fired straight after,
         putting it back. The re-add came from THIS handler. It derived intent
         from the clicked switch's own aria-checked, but refresh() had already
         replaced the drawer's markup and the repaint had already rewritten
         aria-checked on every switch, so the next read saw a value this code had
         just written rather than the customer's intent, and asked for ON again.

         Intent no longer comes from the DOM. protToggle() reads the live cart,
         which is the only thing that cannot go stale, and flips from that. */
      protToggle(parseInt(tg.getAttribute('data-protection'), 10));
      return;
    }

    /* 2026-09-15 Ales notes 4+5+8: a card starts unselected; tapping + ADD adds that product now.
       The button turns into Added + tick at once; the /cart/add hook re-renders the drawer and the
       rail comes back identical (same anchor, same cards), with this card rendered as Added. */
    var qs = e.target.closest('.upi .qs');
    if (qs) {
      var card = qs.closest('.upi'), row = card.parentNode, qt = qs.querySelector('.qt'), was = qt ? qt.textContent : '';
      if (qs.getAttribute('aria-pressed') === 'true') {
        /* note 10: ADDED is a toggle - tap again and the product leaves the bag */
        qs.setAttribute('aria-pressed', 'false');
        if (qt) qt.textContent = (row.getAttribute('data-add') || was);
        post('/cart/change.js', { id: card.getAttribute('data-line') || card.getAttribute('data-variant'), quantity: 0 })
          .then(refresh)
          .catch(function () { qs.setAttribute('aria-pressed', 'true'); if (qt) qt.textContent = was; });
        return;
      }
      qs.setAttribute('aria-pressed', 'true');
      if (qt) qt.textContent = (row.getAttribute('data-added') || was);
      post('/cart/add.js', { items: [{ id: parseInt(card.getAttribute('data-variant'), 10), quantity: 1 }] })
        .catch(function () { qs.setAttribute('aria-pressed', 'false'); if (qt) qt.textContent = was; });
      return;
    }

    /* discount code: Shopify applies it at checkout via the discount URL */
    var ap = e.target.closest('[data-discount-apply]');
    if (ap) {
      var inp = drawer.querySelector('[data-discount]');
      var code = inp && inp.value.trim();
      /* 2026-09-29: the language must survive. '/discount/X?redirect=/cart' dropped /hr and /de,
         so the cart and then the whole checkout ran in English (order #1019 saved as en-HR).
         Both paths now come from Shopify's localised routes (data-* on the drawer). */
      var root = (drawer.getAttribute('data-root-url') || '/').replace(/\/$/, '');
      var cartUrl = drawer.getAttribute('data-cart-url') || '/cart';
      if (code) window.location.href = root + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl);
    }
  });

  /* horizontal rail arrows (re-bound after every refresh, the rail is re-rendered) */
  function bindRail() {
    var row = drawer.querySelector('.uprow');
    if (!row) return;
    var pv = drawer.querySelector('.up-prev'), nx = drawer.querySelector('.up-next');
    function step() { var f = row.firstElementChild; return f ? f.getBoundingClientRect().width + 8 : 200; }
    function sync() {
      if (pv) pv.disabled = row.scrollLeft < 4;
      if (nx) nx.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
    }
    if (pv) pv.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (nx) nx.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
    row.addEventListener('scroll', sync, { passive: true });
    sync();
  }
  bindRail();

  /* "Add all three · €370,00" - the count as a word, then the summed price,
     exactly as the mockup writes it. Both halves are translated. */
  function paintLadder() {
    var lad = drawer.querySelector('.lad');
    if (!lad) return;
    var cents = parseInt(lad.getAttribute('data-goods'), 10) || 0;
    lad.querySelectorAll('[data-tier]').forEach(function (t) {
      t.classList.toggle('hit', cents >= parseInt(t.getAttribute('data-tier'), 10));
    });
    /* markers sit at the bar's ends and middle (Ales, 2026-09-15), so the fill runs between
       them: nothing before EUR 95, 0-50% from 95 to 100, 50-100% from 100 to 200 */
    var pct = cents <= 9500 ? 0 : cents <= 10000 ? (cents - 9500) / 500 * 50 : 50 + (cents - 10000) / 10000 * 50;
    var bar = lad.querySelector('[data-ladder-bar]');
    if (bar) bar.style.width = Math.max(0, Math.min(100, pct)) + '%';
  }

  paintLadder();

  /* 2026-09-24: same guard as the cart page. Shipping protection is an add-on to
     real goods and must not outlive them: removing the last product from THIS
     drawer would otherwise leave a cart holding only the EUR 5,90 line, which
     renders as an empty bag the customer could still be charged for. Reads
     /cart.js so Shopify decides, and only acts when the line is truly orphaned. */
  (function dropOrphanProtection() {
    /* The id is written literally: this block is not processed by Liquid, so an
       interpolated value would ship as raw text. It matches prot_variant above. */
    var PROT = 56756476346754;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.items || !c.items.length) return;
        var prot = null, goods = 0;
        c.items.forEach(function (i) {
          if (i.variant_id === PROT) { prot = i; } else { goods += i.quantity; }
        });
        if (!prot || goods > 0) return;
        return post('/cart/change.js', { id: prot.key, quantity: 0 }).then(refresh);
      })
      .catch(function () {});
  })();

  if (cartPageOnPhone) refresh().then(open);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s2g-header"]) return;
  try {
    
(function () {
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* The announcement bar cross-fades one offer at a time, every 3.2s, exactly
     as the mockup does. Reduced motion keeps the first line and never rotates. */
  var ab = Array.prototype.slice.call(document.querySelectorAll('#ann b')), ai = 0;
  if (ab.length > 1 && !rm) {
    setInterval(function () {
      ab[ai].classList.remove('on');
      ai = (ai + 1) % ab.length;
      ab[ai].classList.add('on');
    }, 3200);
  }

  /* The header takes .on once #hsent has scrolled past the top: grey bar,
     blur, and the lockup scaled to .68. Watching a sentinel rather than a
     scroll handler is the mockup's own approach. */
  var hd = document.getElementById('hd'), sent = document.getElementById('hsent');
  /* 2026-09-15 Ales note 13: on phones the grey bar must come at the first pixel of scroll (the
     transparent header over a light hero photo is unreadable), so below 900px a scroll listener
     drives .on and the sentinel only drives desktop. */
  var phone = window.matchMedia('(max-width:899px)');
  if (hd && sent && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      if (phone.matches) return;
      var e = es[0];
      hd.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(sent);
  }
  if (hd) {
    var onScroll = function () { if (phone.matches) hd.classList.toggle('on', window.scrollY > 0); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();

/* 2026-09-15 Ales note 1: Shop and Concerns are real dropdowns. The chevron was already drawn
     by the port but nothing opened - the mockup's menu was never carried over. Same state contract
     as the burger above: the `hidden` attribute is the truth, aria-expanded mirrors it. */
  (function () {
    var btns = Array.prototype.slice.call(document.querySelectorAll('[data-s2g-dd]'));
    if (!btns.length) return;
    function panel(b) { return document.getElementById(b.getAttribute('aria-controls')); }
    function shut(except) {
      btns.forEach(function (b) {
        if (b === except) return;
        var p = panel(b);
        if (p) p.hidden = true;
        b.setAttribute('aria-expanded', 'false');
      });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var p = panel(b);
        if (!p) return;
        var willOpen = p.hidden;
        shut(b);
        p.hidden = !willOpen;
        b.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.ddw')) shut(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') shut(null);
    });
  })();
/* Burger toggle for the mobile panel. The bag icons carry
   data-cart-drawer-open, which the drawer section already listens for. */
(function () {
  var burger = document.querySelector('[data-s2g-burger]');
  var menu = document.getElementById('s2gMobileMenu');
  if (!burger || !menu) return;
  /* 2026-09-29 Ales (phone): the panel sat at a fixed top:96px, but the header with its
     SkinCeuticals row is taller than that, so the wordmark lay over "All products"; and the
     panel could not scroll, so the language select was below the screen. The panel now starts
     at the header's real bottom edge and is capped to the screen height (CSS scrolls it), and
     the header turns solid while it is open. */
  var hdr = document.getElementById('hd');
  function place() {
    var b = hdr ? Math.round(hdr.getBoundingClientRect().bottom) : 96;
    menu.style.top = b + 'px';
    menu.style.maxHeight = 'calc(100dvh - ' + b + 'px)';
  }
  burger.addEventListener('click', function () {
    var open = !menu.hidden;
    if (!open) place();
    menu.hidden = open;
    burger.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (hdr) hdr.classList.toggle('mopen', !open);
  });
  window.addEventListener('resize', function () { if (!menu.hidden) place(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !menu.hidden) {
      menu.hidden = true;
      burger.setAttribute('aria-expanded', 'false');
      if (hdr) hdr.classList.remove('mopen');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s2g-home"] && !Shopify.designMode) return;
  try {
    
/* Home behaviour, ported from the mockup's own script:
     - hero carousel: no timed auto-advance, arrows and dots drive it, and it
       resets to slide 1 when it re-enters the viewport after being fully out,
       but never while the customer has interacted with it
     - slide 2 plays its film when it is the current slide, pauses otherwise
     - the routine: clicking a step, or the arrows, changes step AND picture
     - the bestsellers rail: scrolls by one card, keeps its counter in sync */
(function () {
  /* rm gates DECORATIVE motion only - the sliding transition and the Ken
     Burns zoom. It must NOT stop the carousels advancing: Ales runs Windows
     with animations off, which turned both carousels off entirely and left
     the play button showing a Play triangle. Reduced motion means cut
     instead of slide, not withhold the content. See _rm.py. */
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rmMotion = rm;   /* transitions and zoom */
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

/* hero: three slides, one film each (DUA-style, 2026-10-08).
     A slide plays its film once; 'ended' starts the next slide. The tab line is
     drawn from the film's currentTime, so it is the film's own clock. Only the
     current film and the next one are ever requested, and phones get the
     540x960 file. Reduced motion only removes the fades (CSS). Save-Data or a
     refused autoplay: stills, a 4s timer, the line jumps full. Offscreen or a hidden tab pauses everything. */
  var hx = document.querySelector('.s2g-home.hx');
  if (hx && !hx.dataset.hxBound) {
    hx.dataset.hxBound = '1';
    var tabs = $$('.hx-tab', hx), panes = $$('.hx-p', hx), media = $$('.hx-m', hx);
    var vids = media.map(function (m) { return $('.hx-v', m); });
    var pp = $('.hx-pp', hx), mqM = matchMedia('(max-width:1000px)');
    var saveData = !!(navigator.connection && navigator.connection.saveData);
    var still = saveData, cur = 0, paused = false, inView = true, timer = 0, raf = 0, STILL_MS = 4000;
    function srcFor(v) { return mqM.matches ? v.getAttribute('data-m') : v.getAttribute('data-d'); }
    function arm(i) { var v = vids[i]; if (!v || still) return; var s = srcFor(v); if (v.getAttribute('src') !== s) { v.preload = 'auto'; v.setAttribute('src', s); } }
    function bar(f) { var b = $('.hx-bar i', tabs[cur]); if (b) b.style.width = (Math.max(0, Math.min(1, f)) * 100) + '%'; }
    function tick() { var v = vids[cur]; if (v && v.duration) bar(v.currentTime / v.duration); raf = requestAnimationFrame(tick); }
    function running() { return !paused && inView && !document.hidden; }
    function stopAll(keep) { clearTimeout(timer); cancelAnimationFrame(raf); vids.forEach(function (v, i) { if (v && i !== keep && !v.paused) v.pause(); }); }
    function run() {
      if (!running()) { stopAll(-1); return; }
      stopAll(cur);
      var v = vids[cur];
      if (still || !v) { bar(1); timer = setTimeout(function () { go(cur + 1); }, STILL_MS); return; }
      arm(cur); arm((cur + 1) % vids.length);
      var p = v.play();
      /* only a real refusal means stills; an AbortError is just a play() that a
         later pause()/play() superseded, and must not switch the films off */
      if (p && p.catch) p.catch(function (e) { if (!e || (e.name !== 'NotAllowedError' && e.name !== 'NotSupportedError')) return; still = true; vids.forEach(function (x) { x.classList.remove('ready'); }); run(); });
      raf = requestAnimationFrame(tick);
    }
    function go(n) {
      $$('.hx-bar i', hx).forEach(function (b) { b.style.width = '0'; });
      cur = (n + tabs.length) % tabs.length;
      tabs.forEach(function (t, i) { var on = i === cur; t.classList.toggle('on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
      panes.forEach(function (p, i) { var on = i === cur; p.classList.toggle('on', on); if (on) { p.removeAttribute('aria-hidden'); p.removeAttribute('inert'); } else { p.setAttribute('aria-hidden', 'true'); p.setAttribute('inert', ''); } });
      media.forEach(function (m, i) { m.classList.toggle('on', i === cur); });
      var v = vids[cur]; if (v && !still) { try { v.currentTime = 0; } catch (e) {} }
      run();
    }
    vids.forEach(function (v, i) {
      if (!v) return;
      v.addEventListener('playing', function () { v.classList.add('ready'); });
      v.addEventListener('ended', function () { if (i === cur && running()) go(cur + 1); });
      v.addEventListener('error', function () { if (!v.getAttribute('src')) return; still = true; v.classList.remove('ready'); if (i === cur) run(); });
    });
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { go(i); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, d = (k === 'ArrowDown' || k === 'ArrowRight') ? 1 : (k === 'ArrowUp' || k === 'ArrowLeft') ? -1 : 0;
        if (!d) return; e.preventDefault(); go(cur + d); tabs[cur].focus();
      });
    });
    function paintPP() { pp.classList.toggle('paused', paused); pp.setAttribute('aria-label', paused ? pp.getAttribute('data-play') : pp.getAttribute('data-pause')); }
    if (pp) pp.addEventListener('click', function () { paused = !paused; paintPP(); run(); });
    document.addEventListener('visibilitychange', run);
    if (mqM.addEventListener) mqM.addEventListener('change', function () { vids.forEach(function (v) { if (v) { v.removeAttribute('src'); v.classList.remove('ready'); v.load(); } }); go(cur); });
    if (window.IntersectionObserver) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; run(); }, { threshold: 0.05 }).observe(hx);
    go(0);
  }

  /* the routine */
  $$('.s2g-home .stack').forEach(function (st) {
    var its = $$('.it', st), wrap = st.closest('.acar');
    if (!wrap) return;
    var ctl = $('.ctl', wrap), cnt = $('.cnt', ctl), play = $('.play', ctl);
    var imgs = $$('.acar-img img', wrap), i = 0, on = true, everOut = false, interacted = false;
    function set(n) {
      i = (n + its.length) % its.length;
      its.forEach(function (x, m) { x.classList.toggle('on', m === i); });
      imgs.forEach(function (im, m) { im.classList.toggle('on', m === i); });
      if (cnt) cnt.textContent = (i + 1) + '/' + its.length;
    }
    function sync() {
      wrap.classList.toggle('paused', !on);
      if (!play) return;
      play.classList.toggle('paused', !on);
      play.setAttribute('aria-label', on ? 'Pause' : 'Play');
    }
    /* The step advances when its own 4.5s `prog` bar finishes, so the bar and
       the change can never drift apart. The mockup draws the bar and the pause
       button but never advances - see _auto2.py. `.acar.paused .rule::before`
       already pauses the animation, so the existing button freezes both. */
    var routineStopped = false, routineSeen = true;
    function routineHandOver() { routineStopped = true; wrap.classList.add('paused'); }

    st.addEventListener('animationend', function (e) {
      if (e.animationName !== 'prog') return;
      if (routineStopped || !on || !routineSeen) return;
      set(i + 1);
      restartBar();
    });

    /* re-running the same animation on a new element needs a reflow between the
       two states, or the browser coalesces them and the bar never restarts */
    function restartBar() {
      var r = its[i] && its[i].querySelector('.rule');
      if (!r) return;
      var b = r.style;
      b.animation = 'none';
      void r.offsetWidth;
      b.animation = '';
    }

    its.forEach(function (x, n) {
      var h = $('h3', x);
      if (h) h.addEventListener('click', function () { interacted = true; routineHandOver(); set(n); });
    });
    var p = $('.prev', ctl), nx = $('.next', ctl);
    if (p) p.addEventListener('click', function () { interacted = true; routineHandOver(); set(i - 1); });
    if (nx) nx.addEventListener('click', function () { interacted = true; routineHandOver(); set(i + 1); });
    if (play) play.addEventListener('click', function () {
      interacted = true; on = !on;
      /* pressing play after a pause resumes the rotation rather than only
         un-dimming the control */
      if (on) { routineStopped = false; restartBar(); }
      sync();
    });
    set(0); sync();
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (es) {
        var e = es[0];
        if (!e.isIntersecting) { everOut = true; return; }
        if (everOut && !interacted) set(0);
        everOut = false;
      }, { threshold: 0 }).observe(wrap);

      /* do not burn through the steps while the section is off screen */
      new IntersectionObserver(function (es) {
        routineSeen = es[0].isIntersecting;
        if (routineSeen && on && !routineStopped) restartBar();
      }, { threshold: 0.2 }).observe(wrap);
    }
  });

  /* the bestsellers rail */
  $$('.s2g-home[data-rail]').forEach(function (sec) {
    var rail = $('.cards', sec), ctl = $('.ctl', sec);
    if (!rail || !ctl) return;
    var tiles = Array.prototype.slice.call(rail.children);
    if (!tiles.length) return;
    var cnt = $('.cnt', ctl), pv = $('.prev', ctl), nx = $('.next', ctl);
    function pad(n) { return ('0' + n).slice(-2); }
    function step() { return tiles[0].getBoundingClientRect().width + 8; }
    function upd() {
      var k = Math.round(rail.scrollLeft / step());
      if (cnt) cnt.textContent = pad(Math.min(k, tiles.length - 1) + 1) + ' / ' + pad(tiles.length);
      if (pv) pv.disabled = rail.scrollLeft < 4;
      if (nx) nx.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    }
    if (pv) pv.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (nx) nx.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s2g-search"]) return;
  try {
    
/* Sort, ported from the mockup. Search has no concern chips, only the sort. */
(function () {
  var grid = document.getElementById('s2g-grid');
  var sel = document.getElementById('s2g-sortsel');
  if (!grid || !sel) return;
  var wraps = Array.prototype.slice.call(grid.children);
  sel.addEventListener('change', function () {
    var mode = sel.value, arr = wraps.slice();
    if (mode === 'price-asc') arr.sort(function (a, b) { return (+a.dataset.price) - (+b.dataset.price); });
    else if (mode === 'price-desc') arr.sort(function (a, b) { return (+b.dataset.price) - (+a.dataset.price); });
    else if (mode === 'az') arr.sort(function (a, b) { return (a.dataset.name || '').localeCompare(b.dataset.name || ''); });
    arr.forEach(function (w) { grid.appendChild(w); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
